import * as React from 'react';
export const clockSvg = React.forwardRef(function clockSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.75 3.75C8.75 3.34 8.41 3 8 3s-.75.34-.75.75V9c0 .26.14.51.36.64l2.5 1.5c.36.22.82.1 1.03-.25.22-.39.1-.82-.25-1.03L8.75 8.578V3.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 8a8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8c4.43 0 8 3.581 8 8Zm-1.5 0A6.5 6.5 0 1 1 8 1.5c3.6 0 6.5 2.91 6.5 6.5Z',
    }),
  );
});
clockSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var clock = {
  category: 'icon',
  colorable: true,
  name: 'clock',
  svg: clockSvg,
};
